import React from 'react';
import { Navbar, Hero, Metrics, Testimonials1, PainPoints } from '../components/SectionsPart1';
import { Tomes, Bonuses, ScarcitySection, Pricing } from '../components/SectionsPart2';
import { Comparison, PremiumBlock, Testimonials2, Guarantee, FAQ, FinalCTA, Footer } from '../components/SectionsPart3';
export default function Home() {
  return <div className="min-h-screen flex flex-col w-full overflow-x-hidden" data-id="element-309">
      <Navbar data-id="element-310" />
      <main data-id="element-311">
        <Hero data-id="element-312" />
        <Metrics data-id="element-313" />
        <Testimonials1 data-id="element-314" />
        <PainPoints data-id="element-315" />
        <Tomes data-id="element-316" />
        <Bonuses data-id="element-317" />
        <ScarcitySection data-id="element-318" />
        <Pricing data-id="element-319" />
        <Comparison data-id="element-320" />
        <PremiumBlock data-id="element-321" />
        <Testimonials2 data-id="element-322" />
        <Guarantee data-id="element-323" />
        <FAQ data-id="element-324" />
        <FinalCTA data-id="element-325" />
      </main>
      <Footer data-id="element-326" />
    </div>;
}